export default "__VITE_ASSET__CA7mL0j3__"